module.exports = __webpack_public_path__ + "static/img/code.3442257.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/comment/code.png
// module id = T5yV
// module chunks = 11